import {
  EditorState,
} from 'draft-js';
import {
  BaseFormViewModel,
} from '../../types';
import {
  ReleaseNotesDTO,
} from './releaseNotesDTO';

export class ReleaseNotesFormViewModel extends BaseFormViewModel<ReleaseNotesDTO> {
  releaseNotesId: number;

  isActive: boolean;

  title: string;

  body: EditorState;

  appVersion: string;

  constructor(dto: ReleaseNotesDTO) {
    super();
    const {
      releaseNotesId,
      isActive,
      title,
      body,
      appVersion,
    } = dto;
    Object.assign(this, {
      releaseNotesId,
      isActive,
      title,
      body,
      appVersion,
    });
  }

  toDTO() {
    return {
    } as ReleaseNotesDTO;
  }
}
